import NewGroupNameModal from "./new-group-name-modal";

export default NewGroupNameModal;